import React, { useEffect } from 'react';
import styled from 'styled-components';
import Breadcrumb from '../../../../../components/Breadcrum';
import './Chickpeas.css';

const competencies = [
  'It is an active ingredient in indian cuisine, which is made into curries and snacks.',
  'Manganese for energy production & iron boost.',
  'Chickpeas can be used almost in every food item.',
  'It is also used along with salads and taken as healthy food item.',
  'Chick peas are enjoyed as desserts or sweets when you are completed with your lunch or dinner.',
  'Chickpeas can also be converted into powdered form and it can be preserved longer.',
  'Helps in stabilizing blood sugar.',
];
const half = Math.ceil(competencies.length / 2);
const leftCompetencies = competencies.slice(0, half);
const rightCompetencies = competencies.slice(half);
const TableContainer = styled.div`
  padding: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const HeaderCell = styled(TableCell)`
  background-color: #b7d283;
  font-weight: bold;
  color: #0a0a0a;
`;

const DataCell = styled(TableCell)`
  background-color: white;
  color: #0a0a0a;
`;

const DataCellDark = styled(TableCell)`
  background-color: #b7d283;
  color: #0a0a0a;
`;
export default function Chickpeas() {
  useEffect(() => {
          window.scrollTo(0, 0);
        }, []);
  return (
    <>
      <Breadcrumb
        title="CHICKPEAS"
        backgroundImage='./assets/img/contact-banner.png'
        height="40vh"
      ></Breadcrumb>
      <section className="main-services cardContainer pt-5 chickpeas">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="service-item">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="left-image">
                      <img src='./assets/img/agriculturalCommodities/agri_1920X500 (1).jpg' alt="Chickpeas" />
                    </div>
                  </div>
                  <div className="col-lg-12 align-self-center">
                    <div className="right-text-content">
                      <i className="fas fa-archive"></i>
                      <span className="heading">Overview of Chickpeas</span>
                      <span className="subData">
                        Leading Chickpeas Manufacturers, Suppliers & Exporters of From India
                      </span>
                      <p className="justify">
                        Chickpeas is known as “kabuli chana” which is used to prepare a famous punjabi dish “chhole bhature”. the legume is used in both whole and flour form. kabuli chana is rich in soluble as well as insoluble dietary fiber, making it ideal for a healthy lifestyle. chickpeas in india are grown on moderately heavy soil mainly in the state of madhya pradesh with its season starting mainly from the month of february. india is among the top manufacturers of chickpeas in the world. the leading exporters and suppliers or manufacturers of chickpeas in india are mainly located in the region state of madhya pradesh due to higher production and better quality. india is one of the largest chickpeas producers in the world followed by australia, turkey, myanmar, mexico and canada. the growing export trend of chickpeas in india is bound to go higher as the quality grown here is in high demand all over the world.

                        Chickpeas is a good source of zinc, folate and protein. they are also very high in dietary fiber and thus are a healthy food source, especially as a source of carbohydrates for people with insulin sensitivity or diabetes. they are low in fat, and most of the fat content is polyunsaturated. it is known in names such as bengal gram, dalia, kabuli chana predominantly. kabuli type chickpeas is widely used in vegetables and salads. also used in wide varieties of snacks foods, soups, sweets and condiments. in the middle-east chickpeas is widely consumed in form of the dish known as hummus. the fiber in chickpeas helps to decrease blood cholesterol levels, consumption of chickpeas may help prevent diabetes, chickpeas are a very good source of folic acid, fiber, and manganese. find chickpeas manufacturers in india, chickpeas suppliers in india, chickpeas exporters in india, chickpeas importers in india, kabuli chana manufacturers in india, kabuli chana suppliers in india, kabuli chana exporters in india, kabuli chana importers in india, gujarat, rajkot, unjha, rajasthan, mundra port, nhava sheva port, madhya pradesh, indore, ahmedabad, mumbai, delhi in india and around the world. VAD industries private limited regularly exports to malaysia, indonesia, philippines, thailand, vietnam, saudi arabia, united arab emirates, morocco, kuwait, qatar, uae, usa, singapore, turkey, russia, algeria, jordan, georgia, armenia, yemen, oman, italy, spain, greece, australia, germany, france, london, poland, romania, denmark, sweden, finland, japan, portugal, serbia, norway, south korea, egypt, iraq, china, bulgaria, laos, lithuania, austria, belarus, croatia, taiwan, bahrain, brazil, united states, ireland, mexico, canada, tunisia, iran, afghanistan, ukraine, south africa, united kingdom.
                      </p>
                      <b>HS CODE: 07132010</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     <h4 className='container'>Chickpeas Specifications:</h4> 
    <TableContainer className='container'>
      <div className="table-responsive">
        <Table border="0" cellSpacing="0">
          <tbody>
            <tr>
              <HeaderCell>PROPERTIES</HeaderCell>
              <HeaderCell>VALUES &amp; LIMITS</HeaderCell>
            </tr>
            <tr>
              <DataCell>Product Name:</DataCell>
              <DataCell>Chickpeas / Kabuli Chana</DataCell>
            </tr>
            <tr>
              <DataCellDark>Chickpeas Counts:</DataCellDark>
              <DataCellDark>58-60/ 9 MM, 44-46/ 11 MM, 42-44/ 12 MM</DataCellDark>
            </tr>
            <tr>
              <DataCell>Cleaning:</DataCell>
              <DataCell>Sortex Cleaned</DataCell>
            </tr>
            <tr>
              <DataCellDark>Admixture:</DataCellDark>
              <DataCellDark>0.50% to 1% Max</DataCellDark>
            </tr>
            <tr>
              <DataCell>Broken Kernels:</DataCell>
              <DataCell>1-2% Max</DataCell>
            </tr>
            <tr>
              <DataCellDark>Moisture:</DataCellDark>
              <DataCellDark>12% Max</DataCellDark>
            </tr>
            <tr>
              <DataCell>Place of Origin:</DataCell>
              <DataCell>India</DataCell>
            </tr>
            <tr>
              <DataCellDark>Damaged Kernels:</DataCellDark>
              <DataCellDark>1-3% Max</DataCellDark>
            </tr>
            <tr>
              <DataCell>Discoloured kernels:</DataCell>
              <DataCell>2-3% Max</DataCell>
            </tr>
            <tr>
              <DataCellDark>Weevilled:</DataCellDark>
              <DataCellDark>0.3% Max</DataCellDark>
            </tr>
          </tbody>
        </Table>
      </div>
    </TableContainer>
     <h4 className='container'>Packaging Details:</h4> 
    <TableContainer className='container'>
      <div className="table-responsive">
        <Table border="0" cellSpacing="0">
          <tbody>
            <tr>
              <HeaderCell> TYPES OF BAGS</HeaderCell>
              <HeaderCell>QUANTITY</HeaderCell>
            </tr>
            <tr>
              <DataCell>PP Bag</DataCell>
              <DataCell>25 / 50 KG in New PP Bag</DataCell>
            </tr>
            <tr>
              <DataCellDark>-</DataCellDark>
              <DataCellDark> As Per Customer Requirement</DataCellDark>
            </tr>
          </tbody>
        </Table>
      </div>
    </TableContainer>

    <section className="core-competencies-container">
        <div className="container">
          <div className="heading-subHeading">
            <h4>Chickpeas Benefits and Uses:</h4>
          </div>
          <div className="cardContainer">
            <div className="leftCard">
              <ul>
                {leftCompetencies.map((item, index) => (
                  <li key={index}>
                    <span className="tick">✔</span>

                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="rightCard">
              <ul>
                {rightCompetencies.map((item, index) => (
                  <li key={index}>
                    <span className="tick">✔</span> {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>

    

  )
}